import { render, staticRenderFns } from "./UserSecurityChecker.vue?vue&type=template&id=f528b8cc&scoped=true"
import script from "./UserSecurityChecker.vue?vue&type=script&lang=js"
export * from "./UserSecurityChecker.vue?vue&type=script&lang=js"
import style0 from "./UserSecurityChecker.vue?vue&type=style&index=0&id=f528b8cc&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f528b8cc",
  null
  
)

export default component.exports